import { useThemeStore, type ThemeState } from './store'
import { useShallow } from 'zustand/react/shallow'

export { useThemeStore }
export type { ThemeState }

/**
 * Use with a selector for performance: useTheme(s => s.theme)
 * Without a selector, returns full store (backward-compatible but causes extra re-renders).
 */
export function useTheme(): ThemeState
export function useTheme<T>(selector: (state: ThemeState) => T): T
export function useTheme<T>(selector?: (state: ThemeState) => T) {
  const shallowSelector = useShallow(selector ?? ((s: ThemeState) => s as unknown as T))
  return useThemeStore(shallowSelector)
}

/** Returns only the theme object — stable reference unless theme actually changes */
export const useThemeObject = () => useThemeStore((s) => s.theme)

/** Returns only the theme name string */
export const useThemeName = () => useThemeStore((s) => s.themeName)

/** Returns theme actions only — references are stable */
export const useThemeActions = () =>
  useThemeStore(
    useShallow((s) => ({ setTheme: s.setTheme, setThemeName: s.setThemeName })),
  )
